import React from "react";
import "./InformationalPages.css";
import useTitle from '../hooks/useTitle';
import "./About.css";

const Tou = () => {
  useTitle('Terms of Use');

  return (
    <div className="ffls-info-page">
      <div className="login-box ffls-info-panel">
        <h1>Terms of Use</h1>
        <p>Effective Date: {new Date().toLocaleDateString()}</p>

        <p>
          Welcome to <strong>FFLS.io</strong>. By accessing or using our website, services, or mobile
          applications (collectively, the "Platform"), you agree to comply with and be bound by these
          Terms of Use ("Terms"). If you do not agree to these Terms, you must not use the Platform.
        </p>

        <h2>1. Eligibility</h2>
        <p>
          You must be at least 18 years of age and legally capable of entering into a binding contract to use this Platform.
          Use of the Platform for any unlawful purpose is strictly prohibited.
        </p>

        <h2>2. Services Provided</h2>
        <p>
          FFLS.io provides tools to search for, claim, and manage Federal Firearms License (FFL) dealer listings.
          We do not sell firearms, ammunition, or any controlled items, nor do we conduct FFL transactions directly.
        </p>

        <h2>3. User Accounts</h2>
        <ul>
          <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
          <li>You agree to provide accurate, current, and complete information.</li>
          <li>We reserve the right to suspend or terminate accounts for violations of our Terms.</li>
        </ul>

        <h2>4. Prohibited Activities</h2>
        <p>When using FFLS.io, you agree not to:</p>
        <ul>
          <li>Use the Platform for illegal or prohibited purposes.</li>
          <li>Misrepresent your identity or your affiliation with an FFL.</li>
          <li>Scrape, copy, or reverse-engineer the Platform without written permission.</li>
        </ul>

        <h2>5. Dealer and Listing Information</h2>
        <p>
          Dealer information is provided for reference purposes only. FFLS.io does not guarantee the accuracy,
          completeness, or legality of any listing. You are responsible for verifying all FFL-related information
          before engaging in any transactions.
        </p>

        <h2>6. Intellectual Property</h2>
        <p>
          All content, trademarks, and service marks on FFLS.io are the property of their respective owners.
          You may not copy, modify, or distribute content without permission.
        </p>

        <h2>7. Disclaimer of Warranties</h2>
        <p>
          FFLS.io is provided on an "AS IS" and "AS AVAILABLE" basis. We disclaim all warranties, express or implied,
          including merchantability, fitness for a particular purpose, and non-infringement.
        </p>

        <h2>8. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, FFLS.io, its owners, employees, and affiliates shall not be liable
          for any damages arising from your use of the Platform.
        </p>

        <h2>9. Changes to Terms</h2>
        <p>
          We reserve the right to update these Terms at any time. Continued use of the Platform after changes
          are posted constitutes your acceptance of the revised Terms.
        </p>

        <h2>10. Governing Law</h2>
        <p>
          These Terms shall be governed by the laws of the State of California, without regard to its conflict of law principles.
        </p>

        <h2>11. Contact Information</h2>
        <p>
          For questions regarding these Terms, please email us at:
          &nbsp;<a href="mailto:support@ffls.io">support@ffls.io</a>
        </p>
      </div>
    </div>
  );
};

export default Tou;
